// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isArray from "lodash/isArray";
import mergeWith from "lodash/mergeWith";

export const mergeWithCss = <TObject1, TObject2>(object1: TObject1, object2: TObject2): TObject1 & TObject2 => {
    return mergeWith({}, object1, object2, (destObj, srcObj) => {
        if (isArray(destObj)) {
            return destObj.concat(srcObj);
        }
    });
};
